<template>
  <div class="section">
    <div class="section-header"><h3>선택사항</h3></div>
    <div class="section-body">
      <dl class="field-group">
        <dt class="field-label">
          보안등급
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text" v-if="registration.prmsLinePcnt === ''">
              선택안함
            </p>
            <p class="data-text" v-if="registration.prmsLinePcnt !== ''">
              온라인가입가능회선수 {{ prmsLinePcnt }}
            </p>
          </div>
        </dd>
      </dl>
      <dl class="field-group">
        <dt class="field-label">
          대리인 가입
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text">
              <span v-if="registration.agntEntrRstnYn === 'Y'"
                >대리인가입 제한</span
              >
              <span v-if="registration.agntEntrRstnYn === 'N'"
                >대리인가입 비제한</span
              >
            </p>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
export default {
  name: 'SecureOptionSectionView',

  props: {
    registrationProps: Object
  },

  data() {
    return {
      registration: {}
    }
  },

  mounted() {
    this.registration = this.registrationProps
  },

  computed: {
    /** 
     * Function    : prmsLinePcnt
     * Description : 가입가능회선명
     **/
    prmsLinePcnt() {
      if (this.registration.prmsLinePcnt === '0') return '비제한'
      if (this.registration.prmsLinePcnt === '2') return '2회선'
      if (this.registration.prmsLinePcnt === '3') return '3회선'
      return ''
    }
  }
}
</script>

<style scoped></style>
